module.exports = __webpack_public_path__ + "static/img/star2-yellow.244acb23.png";